import { Link, useLocation } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="mx-auto flex max-w-[1440px] flex-col items-center justify-center px-4 py-20 text-center md:px-6 md:py-28">
        <div className="font-heading text-7xl font-black text-background-300 md:text-9xl">404</div>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">页面不存在或已调整</h1>
        <p className="mt-2 text-sm text-secondary-500">你访问的页面可能已删除或链接有误，试试从下面重新出发。</p>
        <p className="mt-1 font-mono text-xs text-secondary-400">{location.pathname}</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/category/news"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-newspaper-line"></i>
            浏览新闻频道
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}